import { render } from "./GemMechanism02.vue?vue&type=template&id=abcd2f20&scoped=true"
const script = {}

import "./GemMechanism02.vue?vue&type=style&index=0&id=abcd2f20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abcd2f20"]])

export default __exports__